
export enum UserMessageEnum {
    DomainAlert = 'join_group_through_domain_alert',
    WelcomeTour = 'welcome_tour_alert',
    SurveyMonkey = 'survey_monkey_alert',
    CompleteProfileAlert = 'complete_profile_alert'
}

export default class UserMessageModel {
    messageSeenId?: string;
    messageType: UserMessageEnum;
    messageData: any;
    showUserAlert: boolean;
}
